import { Display, DisplayProps } from '@bonusly/design-system';

export const PageHeading = ({ children, ...props }: DisplayProps) => {
	return (
		<Display as="h1" size="sm" role="heading" {...props}>
			{children}
		</Display>
	);
};
